export default "__VITE_ASSET__CQYZc5YR__"